// Component for displaying and managing clothes
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';

const Clothes = () => {
  const [clothes, setClothes] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState({
    category: '',
    color: '',
    size: '',
    season: '',
    brand: '',
    material: '',
    pattern: '',
    sleeveLength: '',
  });
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [expandedItems, setExpandedItems] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    fetchClothes(); // Fetch clothes data on component load
  }, []);

  const fetchClothes = async () => {
    try {
        const token = localStorage.getItem('token');
        const config = {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true
        };
        const response = await axios.get('http://localhost:3000/api/clothes', config);
        setClothes(response.data);
    } catch (error) {
        console.error('Error fetching clothes:', error.response ? error.response.data : error.message);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value
    }));
  };

  const handleDelete = async (id) => {
    try {
        const token = localStorage.getItem('token'); // Retrieve the access token
        console.log('Token being used:', token);
        const config = {
          headers: { Authorization: `Bearer ${token}` }
        };
        console.log('Deleting item with id:', id);
        const response = await axios.delete(`http://localhost:3000/api/clothes/${id}`, config);
        console.log(response.data);
        fetchClothes(); // Refresh the clothes list after deletion
    } catch (error) {
        console.error('Error deleting clothing item:', error.response ? error.response.data : error.message);
    }
  };

  const toggleItemDetails = (clothId) => {
    setExpandedItems((prevState) => ({
      ...prevState,
      [clothId]: !prevState[clothId], // Toggle only the clicked item
    }));
  };
  
  const handleClick = (e, clothId) => {
    e.stopPropagation(); // Prevent click propagation to avoid affecting other items
    toggleItemDetails(clothId);
  };

  const filteredClothes = clothes.filter((cloth) => {
    return (
      cloth.cloth_name.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (filters.category ? cloth.category.some(cat => cat.toLowerCase().includes(filters.category.toLowerCase())) : true) &&
      (filters.color ? cloth.color.some(col => col.toLowerCase().includes(filters.color.toLowerCase())) : true) &&
      (filters.size ? cloth.size.toLowerCase().includes(filters.size.toLowerCase()) : true) &&
      (filters.season ? cloth.season.some(sea => sea.toLowerCase().includes(filters.season.toLowerCase())) : true) &&
      (filters.brand ? cloth.brand.toLowerCase().includes(filters.brand.toLowerCase()) : true) &&
      (filters.material ? cloth.material.toLowerCase().includes(filters.material.toLowerCase()) : true) &&
      (filters.pattern ? cloth.pattern.toLowerCase().includes(filters.pattern.toLowerCase()) : true) &&
      (filters.sleeveLength ? cloth.sleeveLength.toLowerCase().includes(filters.sleeveLength.toLowerCase()) : true)
    );
});

  return (
    <div className="clothes-container">
      <h1><strong>𝒞𝓁𝑜𝓉𝒽𝑒𝓈 ({clothes.length})</strong></h1> {/* Clothes count */}
      
      <button onClick={() => setIsDropdownOpen(!isDropdownOpen)} className="dropdown-btn">
        <i class="fa-solid fa-magnifying-glass"></i> <strong>𝒮𝑒𝒶𝓇𝒸𝒽 𝐹𝒾𝓁𝓉𝑒𝓇𝓈</strong>
      </button>

      <button onClick={() => navigate('/upload')} className="upload-btn">
        <i className="fa-solid fa-plus"></i> <strong>𝒰𝓅𝓁𝑜𝒶𝒹</strong>
      </button>
      
      {isDropdownOpen && (
        <div className="search-container">
          <div className="filters-container">
            <label>
              <strong>Cloth Name:</strong>
              <input
                type="text"
                placeholder="Search by name"
                value={searchTerm}
                onChange={handleSearchChange}
              />
            </label>
            <label>
              <strong>Category:</strong>
              <input
                type="text"
                placeholder="e.g. T-Shirts, Pants..."
                name="category"
                value={filters.category}
                onChange={handleFilterChange}
              />
            </label>
            <label>
              <strong>Color\-s:</strong>
              <input
                type="text"
                placeholder="Search by color"
                name="color"
                value={filters.color}
                onChange={handleFilterChange}
              />
            </label>
            <label>
              <strong>Size:</strong>
              <input
                type="text"
                placeholder="e.g. L or Large"
                name="size"
                value={filters.size}
                onChange={handleFilterChange}
              />
            </label>
            <label>
              <strong>Season:</strong>
              <input
                type="text"
                placeholder="Winter, Summer, Autumn, Spring"
                name="season"
                value={filters.season}
                onChange={handleFilterChange}
              />
            </label>
            <label>
              <strong>Brand:</strong>
              <input
                type="text"
                placeholder="e.g. Nike, Adidas"
                name="brand"
                value={filters.brand}
                onChange={handleFilterChange}
              />
            </label>
            <label>
              <strong>Material:</strong>
              <input
                type="text"
                placeholder="e.g. Cotton, Polyester"
                name="material"
                value={filters.material}
                onChange={handleFilterChange}
              />
            </label>
            <label>
              <strong>Pattern:</strong>
              <input
                type="text"
                placeholder="e.g. Curduroy"
                name="pattern"
                value={filters.pattern}
                onChange={handleFilterChange}
              />
            </label>
            <label>
              <strong>Sleeve Length:</strong>
              <input
                type="text"
                placeholder="e.g. Long/short sleeve"
                name="sleeveLength"
                value={filters.sleeveLength}
                onChange={handleFilterChange}
              />
            </label>
          </div>
        </div>
      )}
          
      <div className="clothes-grid">
        {filteredClothes.map(cloth => (
          <div
            key={cloth._id}
            className={`clothing-item ${expandedItems[cloth._id] ? 'expanded' : ''}`}
            onClick={() => toggleItemDetails(cloth._id)}
            role="button" // Adds role for accessibility
            aria-expanded={expandedItems[cloth._id] ? 'true' : 'false'} // Indicating expanded state
            aria-controls={`cloth-details-${cloth._id}`} // Controls the details section
            tabIndex={0} // Makes the item focusable
          >
          <h4 className="clothing-name"><strong>{cloth.cloth_name}</strong></h4>
          <p><img src={cloth.image_url} alt={cloth.name} className="clothing-image" /></p>
            
          {/* Only show details when the item is expanded */}
          {expandedItems[cloth._id] && (
            <div className="clothing-details">
              <p><strong>Category:</strong> {cloth.category}</p>
              <p><strong>Color:</strong> {cloth.color}</p>
              <p><strong>Size:</strong> {cloth.size}</p>
              <p><strong>Season:</strong> {cloth.season}</p>
              {cloth.brand && <p><strong>Brand:</strong> {cloth.brand}</p>}
              {cloth.material && <p><strong>Material:</strong> {cloth.material}</p>}
              {cloth.pattern && <p><strong>Pattern:</strong> {cloth.pattern}</p>}
              {cloth.sleeveLength && <p><strong>Sleeve Length:</strong> {cloth.sleeveLength}</p>}
            </div>
            )}
            <div className="clothing-actions">
              <button className="edit-btn" onClick={() => navigate(`/edit-cloth/${cloth._id}`)}>
                <i className="fa-solid fa-pencil"></i><strong>𝐸𝒹𝒾𝓉</strong>
              </button>
              <button className="delete-btn" onClick={() => handleDelete(cloth._id)}>
                <i className="fa-solid fa-trash"></i><strong>𝒟𝑒𝓁𝑒𝓉𝑒</strong>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Clothes;